import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { Mail, Shield, Key } from "lucide-react";

export const Route = createFileRoute("/partner/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h2 className="text-2xl font-serif text-primary">Settings</h2>
        <p className="text-sm text-muted-foreground">
          Manage your partner account and API access
        </p>
      </div>

      <div className="border rounded-xl bg-card p-6 space-y-4">
        <h3 className="font-medium flex items-center gap-2">
          <Mail className="h-4 w-4 text-primary" /> Account
        </h3>
        <div className="grid sm:grid-cols-2 gap-4 text-sm">
          <div>
            <div className="text-xs text-muted-foreground mb-1">Email</div>
            <div>{user?.email}</div>
          </div>
          <div>
            <div className="text-xs text-muted-foreground mb-1">User ID</div>
            <div className="font-mono text-xs truncate">{user?.id}</div>
          </div>
        </div>
      </div>

      <div className="border rounded-xl bg-card p-6 space-y-3">
        <h3 className="font-medium flex items-center gap-2">
          <Key className="h-4 w-4 text-primary" /> API Access
        </h3>
        <p className="text-sm text-muted-foreground">
          B2B partners receive an HMAC secret + partner ID for the ETG/RateHawk
          transfer API. Contact us to provision credentials.
        </p>
        <div className="text-xs text-muted-foreground bg-muted/40 rounded-md p-3 font-mono">
          Endpoints: <br />
          POST /api/public/v1/transfers/search <br />
          POST /api/public/v1/transfers/book <br />
          POST /api/public/v1/transfers/status <br />
          POST /api/public/v1/transfers/cancel
        </div>
      </div>

      <div className="border rounded-xl bg-card p-6 space-y-3">
        <h3 className="font-medium flex items-center gap-2">
          <Shield className="h-4 w-4 text-primary" /> Security
        </h3>
        <p className="text-sm text-muted-foreground">
          All requests must include <code>X-Partner-Id</code>,{" "}
          <code>X-Timestamp</code> and <code>X-Signature</code> (HMAC-SHA256)
          headers. Timestamp must be within ±5 minutes.
        </p>
      </div>
    </div>
  );
}
